import React from "react";
import {Box, Stack, Typography} from "@mui/material";
import {getEventoLabel} from "../cobrancasUtils";

const quando = (instante) => {
    if (!instante) return '-';
    const data = new Date(instante);
    if (Number.isNaN(data.getTime())) return '-';
    return new Intl.DateTimeFormat('pt-BR', {timeZone: 'America/Sao_Paulo', dateStyle: 'short', timeStyle: 'short'}).format(data);
};

/* O que o banco avisou e o que o financeiro fez com a cobrança, do mais novo para o mais antigo. */
export default function EventosDaCobranca({eventos = []}) {
    if (!eventos.length) {
        return <Typography variant="body2" color="text.secondary">Nenhum evento ainda.</Typography>;
    }
    return (
        <Stack spacing={1}>
            {eventos.map((evento, index) => (
                <Box key={`${evento.em}-${evento.tipo}-${index}`} sx={{display: 'grid', gridTemplateColumns: {xs: '1fr', sm: '120px minmax(0, 1fr)'}, columnGap: 2}}>
                    <Typography variant="caption" color="text.secondary" sx={{pt: 0.25}}>{quando(evento.em)}</Typography>
                    <Box sx={{minWidth: 0}}>
                        <Typography variant="body2" fontWeight={600}>{getEventoLabel(evento.tipo)}</Typography>
                        {evento.descricao ? <Typography variant="body2" color="text.secondary">{evento.descricao}</Typography> : null}
                    </Box>
                </Box>
            ))}
        </Stack>
    );
}
